<template>
  <card :title="$t('your_info')">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="update"
      @keydown="form.onKeydown($event)"
    >
      <v-container grid-list-xl>
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
            <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="form.type_document"
                  :items="items_type_document"
                  label="Tipo de Documento"
                  placeholder="Tipo de Documento"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.rif"
                  label="Número de Identificación"
                  maxlength="11"
                  placeholder="RIF"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="6">
                <v-select
                  v-model="form.taxpayer_type"
                  :items="items_taxpayer_type"
                  label="Tipo de Contribuyente"
                  placeholder="Tipo de Contribuyente"
                  :readonly="true"
                />
              </v-col>
              <v-col
                  cols="12"
                  md="6">
                  <v-select
                    v-model="form.special_tax"
                    :items="items_special_tax"
                    label="Régimen Especial de Tributación"
                    placeholder="Régimen Especial de Tributación"
                    :readonly="true"
                  />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.name"
                  label="Razón Social"
                  placeholder="Razón Social"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
               >
                <v-text-field
                  v-model="form.email"
                  label="Correo Electrónico"
                  placeholder="ejemplo@dominio.com"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="form.branch_code"
                  label="Sucursal"
                  maxlength="10"
                  placeholder="0001"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="3">
                <v-select
                  v-model="form.cat_province_id"
                  :items="itemsProvince"
                  item-value="id"
                  item-text="name"
                  label="Estado"
                  :readonly="true"
                  @change="getDistrito()"
                />
              </v-col>
              <v-col
                cols="12"
                md="3">
                <v-select
                  v-model="form.cat_district_id"
                  :items="itemsDistrict"
                  item-value="id"
                  item-text="name"
                  label="Municipio"
                  :readonly="true"
                  @change="getCorregimiento()"
                />
              </v-col>
              <v-col
                cols="12"
                md="3">
                <v-select
                  v-model="form.cat_corregimiento_id"
                  :items="itemsCorregimiento"
                  item-value="id"
                  item-text="name"
                  label="Parroquia"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="9"
              >
                <v-text-field
                  v-model="form.address"
                  label="Dirección"
                  placeholder="Dirección"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="form.phone"
                   v-mask="'####-###-####'"
                  label="Teléfono"
                  placeholder="Teléfono 0123-456-7890"
                  maxlength="13"
                  type="tel"
                  :readonly="true"
                />
              </v-col>
            </v-layout>
      </v-container>
    </v-form>
  </card>
</template>

<script>
import Form from 'vform';
import { mask } from 'vue-the-mask';

export default {
  directives: {
    mask,
  },
  metaInfo() {
    return { title: this.$t('settings') };
  },
  data: () => ({
    form: new Form({
        id: '',
        rif: '',
        name: '',
        dv: '',
        type_document: null,
        taxpayer_type: null,
        special_tax: null,
        email: '',
        phone: '',
        address: '',
        branch_code: '',
        cat_corregimiento_id: '',
        cat_district_id: '',
        cat_province_id: '',
        active: '1',
        busy: false,
    }),
    items_type_document: [
      { value: 'J', text: 'JURÍDICO' },
        { value: 'V', text: 'VENEZOLANO' },
        { value: 'C', text: 'CEDULA' },
        { value: 'P', text: 'PASAPORTE' },
        { value: 'G', text: 'GUBERNAMENTAL' },
        { value: 'E', text: 'EXTRANJERO' },
    ],
    items_taxpayer_type: [
      { value: 'FORMAL', text: '  FORMAL' },
      { value: 'ORDINARIO', text: 'ORDINARIO' },
      { value: 'ESPECIAL', text: 'ESPECIAL' },
      { value: 'NO SUJETO', text: 'NO SUJETO' },
    ],
    items_special_tax: [
      { value: 'ZONAS ECONÓMICAS ESPECIALES', text: 'ZONAS ECONÓMICAS ESPECIALES' },
      { value: 'ZONA FRANCA DE PARAGUANÁ', text: 'ZONA FRANCA DE PARAGUANÁ' },
      { value: 'ZONA LIBRE DE PARAGUANÁ', text: 'ZONA LIBRE DE PARAGUANÁ' },
      { value: 'PUERTO LIBRE SANTA ELENA DE UAIRÉN', text: 'PUERTO LIBRE SANTA ELENA DE UAIRÉN' },
      { value: 'ZONA LIBRE DE MÉRIDA', text: 'ZONA LIBRE DE MÉRIDA' },
      { value: 'PUERTO LIBRE EDO. NUEVA ESPARTA', text: 'PUERTO LIBRE EDO. NUEVA ESPARTA' },
      { value: 'DUTTY FREE', text: 'DUTTY FREE' },
      { value: 'OTROS', text: 'OTROS' },
    ],
    valid: false,
    itemsProvince: [],
    itemsDistrict: [],
    itemsCorregimiento: [],
    apiURL: '/api/settings/profileEnterprise',
  }),
  computed: {
    ref() { return this.form.id; },
  },
  watch: {
    'form.cat_province_id': {
      handler() {
        this.getDistrito();
      },
    },
    'form.cat_district_id': {
      handler() {
        this.getCorregimiento();
      },
    },
  },
  async mounted() {
    await this.getProvincia().then((response) => {
      this.itemsProvince = response.data;
    });
      window.axios.get(`${this.apiURL}`)
      .then((result) => {
        Object.assign(this.form, result.data);
      });
  },
  methods: {
    getProvincia() {
      const url = '/api/provinces';
      return window.axios.get(url);
    },
    getDistrito() {
      if (this.form.cat_province_id) {
          const url = `/api/districts/${this.form.cat_province_id}`;
          window.axios.get(url)
          .then((response) => {
          this.itemsDistrict = response.data;
        });
      }
    },
    getCorregimiento() {
      if (this.form.cat_district_id) {
          const url = `/api/corregimientos/${this.form.cat_district_id}`;
          window.axios.get(url)
          .then((response) => {
          this.itemsCorregimiento = response.data;
        });
      }
    },
  },
};
</script>
